import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';

import FormInput from '../../../../containers/shared/forms/form-input';
import FormSelect from '../../../../containers/shared/forms/form-select';
import { selectState } from '../../../../selectors';
import { useFetchRegionsAndCountries } from '../../../shared/hooks';
import { FlexContainerRowInner } from '../../../styled/skylab/page';
import CompanySetupText from './company-setup-text';

const EditCompanyDetails = () => {
  const {
    sharedSignup: { isEditingPrepopulated },
    esb: { esbPartner },
  } = useSelector(selectState);

  const { formattedCountries, formattedRegions } = useFetchRegionsAndCountries();

  return (
    <Fragment>
      <h1 data-ref='buy.esb-company-info.edit-company-details.header'>
        {isEditingPrepopulated ? 'Edit your company details' : 'Complete your company details'}
      </h1>
      {esbPartner && <CompanySetupText />}
      <form className='pad-bottom-md'>
        <fieldset className='margin-right-md'>
          <label htmlFor='company-name'>{t('client.labels.company-name')}</label>
          <FormInput fieldName='companyName' addPadding={true} width='50%' />
        </fieldset>

        <FlexContainerRowInner>
          <fieldset className='margin-top-md margin-right-md'>
            <label htmlFor='country'>{t('client.labels.country')}</label>
            <FormSelect fieldName='country' fieldValues={formattedCountries} />
          </fieldset>
          <fieldset className='margin-top-md'>
            <label htmlFor='phone'>{t('client.labels.phone-number')}</label>
            <FormInput fieldName='phone' addPadding={true} />
          </fieldset>
        </FlexContainerRowInner>

        <label htmlFor='address'>{t('client.labels.address')}</label>
        <FormInput fieldName='street1' addPadding={true} />

        <FlexContainerRowInner>
          <fieldset className='margin-top-md margin-right-md'>
            <label htmlFor='city'>{t('client.labels.city')}</label>
            <FormInput fieldName='city' addPadding={true} width='50%' />
          </fieldset>
        </FlexContainerRowInner>

        <FlexContainerRowInner>
          <fieldset className='margin-top-md margin-right-md'>
            <label htmlFor='state'>{t('client.labels.region')}</label>
            <FormSelect fieldName='state' fieldValues={formattedRegions} />
          </fieldset>
          <fieldset className='margin-top-md'>
            <label htmlFor='postalCode'>{t('client.labels.postal-code')}</label>
            <FormInput fieldName='postalCode' addPadding={true} validateDuringInput={true} />
          </fieldset>
        </FlexContainerRowInner>
      </form>
    </Fragment>
  );
};

export default EditCompanyDetails;
